<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

import appSmartCatalogItem__images_slider from '@/components/app-smart-catalog-item/app-smart-catalog-item__images_slider'
import appSmartCatalogItem__content from '@/components/app-smart-catalog-item/app-smart-catalog-item__content'
import appSmartCatalogItem from '@/components/app-smart-catalog-item/app-smart-catalog-item'
import appSpinner from '@/components/common/app-spinner'
import appProgressBar from '@/components/common/app-progress-bar'

export default {
  name: 'app-smart-catalog',
  components: {
    appSmartCatalogItem,
    appSmartCatalogItem__content,
    appSmartCatalogItem__images_slider,
    appSpinner,
    appProgressBar
  },
  data() {
    return {
      canLoadMore: true
    }
  },
  computed: {
    ...mapGetters({
      leads: 'leads/getLeads',
      isFetching: 'isFetching',
      isLoadLeads: 'leads/isLoadLeads',
      account: 'account/getAccount',
      getCatalogConstantTranslationByKey: 'account/getCatalogConstantTranslationByKey',
    }),
    isMobileVersion() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    },
  },
  methods: {
    ...mapActions({
      loadLeads: 'leads/loadLeads',
      loadAllLeads: 'leads/loadAllLeads',
      loadAccount: 'account/loadAccount'
    }),
    ...mapMutations({
      changeFetching: 'CHANGE_FETCHING'
    }),
    async onScroll() {
      if (this.canLoadMore) {
        const { bottom } = this.$refs.element.getBoundingClientRect()
        if (Math.abs(bottom) <= document.documentElement.clientHeight) {
          this.canLoadMore = false
          await this.loadLeads({ _id: this.$route.params._id, domain: this.$route.params.domain, qs: this.searchParams() })
            .then(() => {
              this.$nextTick(() => {
                this.canLoadMore = true
              })
            })
        }
      }

    },

    searchParams() {
      let qs = location.href.split('?')
      if (qs.length > 1) {
        qs = qs[1]
      } else {
        qs = undefined
      }
      return qs
    }
  },
  mounted() {
    this.changeFetching(true)

    Promise.all(
      [
        this.loadAccount({ _id: this.$route.params._id ,domain: this.$route.params.domain }),
        this.loadLeads({ _id: this.$route.params._id ,domain: this.$route.params.domain, qs: this.searchParams() }),
        this.loadAllLeads({ _id: this.$route.params._id ,domain: this.$route.params.domain })
      ])
      .then(() => {
        this.changeFetching(false)
      })

    window.addEventListener('scroll', this.onScroll)
  },
  unmounted() {
    window.removeEventListener('scroll', this.onScroll)
  }
}
</script>

<template>
  <div class="bg-white w-full">
    <app-spinner
      v-if="isFetching"
    />
    <div>
      <div class="grid xl:grid-cols-3 gap-8 lg:grid-cols-2 md:grid-cols-2"
           ref="element"
           v-if="leads.length"
      >
        <appSmartCatalogItem
          v-for="leadItem of leads"
          :key="leadItem.id"
          :formatFeedback="account.formatFeedback"
          :presUrl="account.presUrl"
          :pId="account.pId"
          :leadName="leadItem.name"
          :leadId="leadItem.id"
          :userId="leadItem.responsible_user_id"
          :isMobileVersion="isMobileVersion"
        >
          <template #images_slider>
            <appSmartCatalogItem__images_slider
              :images="leadItem.images"
              :isMobileVersion="isMobileVersion"
            />
          </template>
          <template #content>
            <appSmartCatalogItem__content
              :name="leadItem.name"
              :price="leadItem.price"
              :numberFormat="leadItem.numberFormat"
              :options="leadItem.options"
            />
          </template>
        </appSmartCatalogItem>
      </div>

      <div
        v-else-if="!isFetching"
        class="flex-grow flex justify-center items-center"
      >
        {{ getCatalogConstantTranslationByKey('no-suitable-objects') }}.
      </div>

      <div
        v-if="isLoadLeads"
        class="mt-8"
      >
        <app-progress-bar
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
</style>
